<template lang="pug">
.wrapper
  section.container.i_ptb_10
    .news_wrapper.d-flex.flex-column.flex-lg-row
      .first_news.d-flex.flex-column.flex-md-row.flex-lg-column
        h2.d-md-none.text-center.i_mb_sm_6 最新消息
        router-link.img(
          v-if="news.length > 0",
          tag="a",
          :to="{ name: 'Detail', query: { type: 'news', id: news[0].ID } }",
          :style="{ backgroundImage: 'url(' + news[0].Image + ')' }",
          @click="toNewsDetailPage(news[0].ID)"
        )
        .content.i_pl_md_3
          h2.d-none.d-md-block.d-lg-none.text-center.text-md-left 最新消息
          router-link(
            v-if="news.length > 0",
            tag="a",
            :to="{ name: 'Detail', query: { type: 'news', id: news[0].ID } }"
          )
            h6(v-if="news.length > 0") {{ news[0].Title }} {{ news[0].PostDate }}
          p(v-if="news.length > 0") {{ news[0].Brief }}
          router-link.see_more_btn.float-right.i_mt_2.d-md-none(
            v-if="news.length > 0",
            tag="a",
            :to="{ name: 'Detail', query: { type: 'news', id: news[0].ID } }"
          ) 詳細內容
      .news_list.i_pl_12.i_pl_md_0
        h2.d-none.d-lg-block.text-center.text-md-left 最新消息
        .news(
          v-for="(announcement, index) in announcements",
          :key="index",
          v-if="setAnnouncementCount(index)"
        )
          router-link.img.d-block.d-md-none(
            tag="a",
            :to="{ name: 'Detail', query: { type: 'announcement', id: announcement.ID } }",
            :style="{ backgroundImage: 'url(' + announcement.Image + ')' }"
          )
          .content
            router-link(
              tag="a",
              :to="{ name: 'Detail', query: { type: 'announcement', id: announcement.ID } }"
            )
              h6 {{ announcement.Title }} {{ announcement.PostDate }}
            p {{ announcement.Brief }}
            router-link.see_more_btn.float-right.i_mt_2.d-md-none(
              tag="a",
              :to="{ name: 'Detail', query: { type: 'announcement', id: announcement.ID } }"
            ) 詳細內容

    .row.text-center
      router-link.see_more_btn.sm.btn_blue_ci.text-center.i_mt_8(
        tag="a",
        :to="{ name: 'AboutUsNews' }"
      ) 看更多
</template>

<script>
import { getNews, getAnnouncement } from "@/json/about_us";

export default {
  name: "News",
  data() {
    return {
      news: [],
      announcements: [],
    };
  },
  created() {
    this.getNews();
    this.getAnnouncement();
  },
  methods: {
    getNews() {
      getNews().then((response) => {
        this.news = response.data.NewsList;
      });
    },
    getAnnouncement() {
      getAnnouncement().then((response) => {
        this.announcements = response.data.AnnouncementList;
      });
    },
    setAnnouncementCount(index) {
      var announcementCount = 0;

      if (this.$store.state.screenWidth <= 767) {
        announcementCount = 1;
      } else {
        announcementCount = 3;
      }

      return index < announcementCount;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/home/news";
</style>
